import { createUseMutation } from 'api/common/createUseMutation'
import { postProjectSync } from 'api/fetchers/postBriefSync'
import { queryClient } from 'app/Root'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const usePostProjectSync = createUseMutation({
  fetcher: postProjectSync,
  onSettled: async () => {
    queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PROJECTS] })
    queryClient.invalidateQueries({ queryKey: [ApiQueryKeys.PROJECT_DETAILED] })
  },
})
